function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h48v48H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.486 23.245c-1.364-1.108-3.151-.615-4.062.28l-.43.423-.43-.424c-.887-.876-2.68-1.399-4.062-.279a2.874 2.874 0 00-.214 4.307L23.5 31.69a.708.708 0 00.986 0l4.214-4.138a2.874 2.874 0 00-.215-4.306zm8.508-3.888a3.71 3.71 0 00-.44-1.758l-2.85-5.334A1.85 1.85 0 0031.945 11h-15.89c-.801 0-1.509.51-1.764 1.271l-2.85 5.334A3.71 3.71 0 0011 19.363c.006 3.511 0 15.78 0 15.78C11 36.17 11.83 37 12.857 37h22.286C36.17 37 37 36.17 37 35.143c0 0-.006-12.269-.006-15.786zm-11.601-5.571h5.966l1.985 3.714h-7.951v-3.714zm-8.752 0h5.966V17.5h-7.95l1.984-3.714zm-2.855 20.428c0-2.118.005-9.489.005-13.928H34.21c0 4.44.005 11.81.005 13.928H13.786z",
  fill: "#38AAFD",
  className: "svg-fill"
});

var SvgMaterial = function SvgMaterial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaterial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/material.ac1127a3.svg";
export { ForwardRef as ReactComponent };